<!-- 用于弹出层刻度尺组件 -->
<template>
  <van-popup v-model="show" round position="bottom" @closed="bindClose">
    <div class="container" v-if="show">
      <div class="close iconfont icon-cha" @click="bindClose"></div>
      <div class="title">选择你的年龄</div>
      <div class="desc">请填写真实信息，确保方案的专业性</div>
      <div class="content">
        <div class="value">
          <span class="number">{{ curNum }}</span>
          <span class="unit">岁</span>
        </div>
        <MyRuler
          style="margin-bottom: 48px"
          @change="bindRulerNum"
          :NowNum="curDefaultNum"
          :maxNum="maxNum"
          theme="#81EF5F"
          :oneGridValue="oneGridValue"
          :minNum="minNum"
        />
        <div class="btn-content">
          <div class="btn-item confirm" @click="bindConfirm">选好了</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import MyRuler from '@/components/app/ruler/ruler.vue'
export default {
  components: {
    MyRuler
  },
  props: {
    zIndex: {
      type: Number,
      default: 2000
    },
    // 每个格子多大
    oneGridValue: {
      type: Number,
      default: 1
    },
    title: {
      //标题
      type: String,
      default: ''
    },
    unit: {
      //单位
      type: String,
      default: ''
    },
    value: {
      //是否显示popup
      type: Boolean,
      default: false
    },
    defaultNum: {
      //刻度尺默认值
      type: Number,
      default: 20
    },
    maxNum: {
      //刻度最大值
      type: Number,
      default: 100
    },
    minNum: {
      //刻度最小值
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,
      curNum: 0,
      curDefaultNum: 0,
      defaultAge: 21
    }
  },
  watch: {
    value() {
      this.show = this.value
      this.curDefaultNum = this.defaultNum || this.defaultAge
      this.curNum = this.curDefaultNum
    }
  },
  computed: {},
  created() {
    this.show = this.value
    this.curDefaultNum = this.defaultNum || this.defaultAge
    this.curNum = this.curDefaultNum
  },
  mounted() {},
  methods: {
    bindRulerNum(value) {
      this.curNum = value
    },
    bindClose() {
      this.$emit('input', false)
    },
    bindConfirm() {
      this.$emit('confirm', this.curNum)
      this.bindClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.van-popup--round {
  border-radius: 8px 8px 0px 0px;
}

.container {
  background: #ffffff
    linear-gradient(187deg, #ebfedf 0px, rgba(255, 255, 255, 0) 100px);
  border-radius: 16px 16px 0px 0px;
  padding: 20px 20px 56px;
  position: relative;

  .close {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.3);
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .title {
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    margin-bottom: 6px;
  }

  .desc {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
    margin-bottom: 46px;
  }

  .content {
    text-align: center;

    .value {
      margin-bottom: 20px;

      .number {
        text-align: right;
        min-width: 44px;
        white-space: nowrap;
        display: inline-block;
        font-size: 32px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #0d0d0d;
        line-height: 37px;
        letter-spacing: 1px;
        margin-right: 10px;
      }

      .unit {
        font-size: 14px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #0d0d0d;
        line-height: 16px;
      }
    }
  }
}

.btn-content {
  padding: 0px 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  .btn-item {
    text-align: center;
    width: 160px;
    height: 42px;
    line-height: 42px;
    background: #0d0d0d;
    border-radius: 21px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
